/**
 * Users
 */

// React
import React, { FunctionComponent, useEffect, useState, useContext } from 'react';

import { useForm } from 'react-hook-form';
// Context
import AuthContext from '../../authContext';

// Redux
import { connect } from 'react-redux';
import { compose } from 'redux';
import {
  getUsersAction,
  updateUserActions,
  createUserActions,
  updateUserStatusActions,
  getCustomersAction,
  getOrgansAction,
  postOrgansAction,
} from './actions';
import { getCentersAction } from '../centers/actions';
import { getPartnersAction } from '../partners/actions';
import { Store } from '../../redux/reducers';

// Selector
import { createStructuredSelector } from 'reselect';
import {
  makeSelectUsersList,
  makeSelectLoading,
  makeSelectError,
  makeSelectCountList,
  makeSelectCustomersList,
  makeSelectOrgansList,
} from './selectors';
import { makeSelectList as makeSelectCentersList } from '../centers/selectors';
import { makeSelectPartnersList } from '../partners/selectors';

// Components
import Pagination from '@material-ui/lab/Pagination';
import RenderFilter from '../../utils/listDaynamicFilterHookForm';
import List from './componets/listHelpical';
import Edit from './componets/edit';
import Add from './componets/add';
import Detail from './componets/detail';
import Assign from './componets/assign';
import Modal from '../../components/Modal';
import Can from '../../components/Can';

// UI
import theme from '../../theme';
import clsx from 'clsx';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import {
  Typography,
  CircularProgress,
  Button,
  Dialog,
  DialogActions,
  Grid,
  DialogTitle,
  IconButton,
  FormControl,
  Select,
  MenuItem,
} from '@material-ui/core';

// Icon
import Icon from '@mdi/react';
import {
  mdiPlus,
  mdiClose,
  mdiCheck,
  mdiAccountDetailsOutline,
  mdiPencilOutline,
  mdiAccountOutline,
  mdiPhoneOutline,
  mdiAccountKeyOutline,
  mdiStateMachine,
  mdiAccountPlusOutline,
} from '@mdi/js';

// Helper
import { removeEmptyValueObject } from '../../utils/helpers';

// Type
import {
  Props,
  SelectorProps,
  PayloadUpdate,
  PayloadCreate,
  User,
} from './interfaces';
import type { Filter } from '../../utils/listDaynamicFilter';
import roleRepository from 'client-sdk/src/Repository/roles-repository';
import useQuery from '../../utils/hook/useQuery';
import { TextField } from '@material-ui/core';

type Inputs = {
  'name.contains': string;
};

// StyleExpansionPanel
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {},
    paper: {},
    loading: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      height: '50vh',
      alignSelf: 'center',
      justifyContent: 'center',
      background: '#ccc',
    },
    pagination: {
      // marginTop: theme.spacing(1),
    },
    textArea: {
      width: '100%',
    },
    searchBox: {
      display: 'flex',
      position: 'relative',
      padding: '10px 0',
      backgroundColor: theme.palette.common.white,
      borderRadius: '4px',
      boxShadow: '0px 2px 4px 1px rgba(0,0,0,0.1)',
    },

    input: {
      marginLeft: theme.spacing(1),
      flex: 2,
      '@media (max-width: 768px)': {
        fontSize: '12px',
      },
    },
    iconButton: {
      padding: 10,
      position: 'relative',
      marginRight: '10px',
      '&:before': {
        content: '""',
        position: 'absolute',
        width: '1px',
        height: '36px',
        top: '4px',
        left: '-9px',
        backgroundColor: '#EDF1F4',
      },
    },
    filterBox: {
      position: 'absolute',
      backgroundColor: '#fff',
      width: '100%',
      top: '47px',
      right: '0',
      marginTop: '30px',
      borderRadius: '0  0 4px  4px',
      padding: '16px 16px',
      boxSizing: 'border-box',
      boxShadow: '0px 2px 4px 1px rgba(0,0,0,0.1)',
      zIndex: 10,
    },

    filterOpen: {
      display: 'block',
    },
    filterClose: {
      display: 'none',
    },
    paginationBox: {
      display: 'flex',
    },
    selectSize: {
      width: '35px',
    },
    subtitle: {
      fontSize: '14px',
      fontWeight: 500,
      color: '#8A8A8A',
    },
    magnifyIcon: {
      transform: 'rotate(-90deg)',
    },
    // Cancel Dialog
    cancelIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      marginBottom: theme.spacing(7),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.error.main,
      },
    },
    cancelTitle: {
      fontSize: '16px',
      fontWeight: 500,
      textAlign: 'center',
      marginBottom: theme.spacing(3),
    },
    actionsBox: {
      paddingTop: theme.spacing(2),
      paddingRight: theme.spacing(3),
      paddingLeft: theme.spacing(3),
    },
    editIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      // marginBottom: theme.spacing(7),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.blue.main,
      },
    },
    addIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.green.main,
      },
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
  })
);

const UsersHelpical: FunctionComponent<Props> = (props: Props) => {
  const [openSize, setOpenSize] = React.useState(false as boolean);
  const [organ, setOrgan] = useState(0)
  const authContext = useContext(AuthContext);
  const [filters, setFilters] = useState([] as Filter[]);
  const { filtersValues, setFiltersValues } = useQuery({
    page: 0,
    size: 10,
  } as any);
  const [openConfirmDisable, setOpenConfirmDisable] = useState(
    false as boolean
  );
  const [roles, setRoles] = useState<any>([]);
  const [openConfirmActive, setOpenConfirmActive] = useState(false as boolean);
  const [openDialog, setOpenDialog] = useState(false as boolean);
  const [type, setType] = useState('edit' as string);
  const [openAdd, setOpenAdd] = useState(false as boolean);
  const [id, setId] = useState(-1 as number);
  const filterTranslator = (fieldName: string) => {
    const status = {
      name: 'نام کاربر',
      'name.equals': 'نام کاربر:',
      'name.contains': 'نام کاربر:',
      phoneNumber: 'شماره تماس کاربر',
      'phoneNumber.equals': 'شماره تماس کاربر',
      'phoneNumber.contains': 'شماره تماس کاربر',
      'id.equals': 'کد کاربر:',
      'id.contains': 'کد کاربر:',
      role: 'نقش کاربر',
      'role.equals': 'نقش کاربر:',
      'role.contains': 'نقش کاربر:',
      emailAddress: 'ایمیل کاربر',
      'emailAddress.equals': 'ایمیل کاربر:',
      'emailAddress.contains': 'ایمیل کاربر:',
    };
    return status[fieldName];
  };
  const removeFilterHandler = (fieldName: any) => {
    const filtered = { ...filtersValues };
    delete filtered[fieldName];
    setFiltersValues(filtered);
  };

  useEffect(() => {
    getCustomers();
    setupFilters();
  }, [filtersValues]); // eslint-disable-line react-hooks/exhaustive-deps
  const classes = useStyles();
  const handleChangePage = (
    event: React.ChangeEvent<unknown>,
    page: number
  ) => {
    setFiltersValues({ ...filtersValues, page: page - 1 });
  };

  useEffect(() => {
    props.getOrganDispatch();

  }, [props.organs]);




  const getCustomers = () => {
    const { page, size } = filtersValues;
    props.costomersDispatch({
      ...removeEmptyValueObject(filtersValues),
      page,
      size,
    });
  };

  const setupFilters = () => {
    setFilters([
      {
        type: 'input',
        id: 'name.contains',
        label: 'نام کاربر',
        icon: mdiAccountOutline,
      },
      {
        type: 'input',
        id: 'phoneNumber.contains',
        label: 'شماره همراه کاربر',
        icon: mdiPhoneOutline,
      },
      {
        type: 'number',
        id: 'id.equals',
        label: 'کد کاربر',
        icon: mdiAccountKeyOutline,
      },
      {
        type: 'checkbox',
        id: 'role.in',
        label: 'نقش کاربر',
        data: [
          'DRIVER',
          'CENTER_ADMIN',
          'PARTNER_ADMIN',
          'RONAD_ADMIN',
          'LOGISTICS_ADMIN',
          'WAREHOUSE_ADMIN',
          'MARKETING_MANAGER',
          'MARKETING_EXPERT',
          'OPERATIONS_MANAGER',
          'OPERATIONS_EXPERT',
          'SUPPORT_MANAGER',
          'SUPPORT_EXPERT',
          'AGENCY_ADMIN',
          'WAREHOUSE_OPERATOR',
          'NONE',
        ],
        translateType: 'user',
        icon: mdiStateMachine,
      },
    ]);
  };
  const headCells = [
    {
      id: 'userName',
      label: 'نام کاربر',
      type: 'input',
    },
    { id: 'userId', label: 'کد کاربر', type: 'input' },
    { id: 'phoneNumber', label: 'شماره تماس کاربر', type: 'input' },
    { id: 'partnerName', label: 'نام شرکت', type: 'input' },
    { id: 'role', label: 'هلپیکال ', type: 'input' },
    // {
    //   id: 'role',
    //   label: 'نقش کاربر',
    //   type: 'checkbox',
    //   data: [
    //     'RONAD_ADMIN',
    //     'MARKETING_MANAGER',
    //     'MARKETING_EXPERT',
    //     'OPERATIONS_MANAGER',
    //     'OPERATIONS_EXPERT',
    //     'SUPPORT_MANAGER',
    //     'SUPPORT_EXPERT',
    //     'WAREHOUSE_SUPERVISOR',
    //     'WAREHOUSE_ADMIN',
    //     'WAREHOUSE_OPERATOR',
    //     'PARTNER_ADMIN',
    //     'AGENCY_ADMIN',
    //     'CENTER_ADMIN',
    //     'SELLER_ADMIN',
    //     'DRIVER',
    //     'LOGISTICS_ADMIN',
    //     'FINANCIAL_SUPERVISOR',
    //   ],
    // },
  ];
  const head = { headCells };
  const handleDisableUser = async () => {
    await props.updateUserStatusDispatch({
      id,
      body: 'SUSPENDED'.replace(/'/g, '"'),
      pagination: filtersValues,
    });

    setOpenConfirmDisable(false);
  };
  const handleActiveUser = async () => {
    await props.updateUserStatusDispatch({
      id,
      body: 'ACTIVE'.replace(/'/g, '"'),
      pagination: filtersValues,
    });

    setOpenConfirmActive(false);
  };

  const handleOpenConfirmDisable = (id: number) => {
    setOpenConfirmDisable(true);

    setId(id);
  };
  const handleOpenConfirmActive = (id: number) => {
    setOpenConfirmActive(true);
    setId(id);
  };
  const handleOpen = (id: number) => {
    setId(id)
    setOpenDialog(true);

  };

  const handleClose = () => {
    setOpenConfirmDisable(false);
    setOpenConfirmActive(false);
    setOpenDialog(false);
    setOpenAdd(false);
    setOpenSize(false);
  };

  const handleOpenConfirmUpdateState = (data: { id: number; body: any }) => {
    setId(data.id);
  };

  const handleChangeSizePage = (event: React.ChangeEvent<{ value: unknown }>) => {
    setFiltersValues({ ...filtersValues, page: 0, size: event.target.value });
  };

  const handleOrgans = () => {
    props.postOrganDispatch({
      userId: id,
      organizationId: organ, callback
    })
    function callback() {
      getCustomers()
      setOpenDialog(false)
    }


  }

  return (
    <div className={classes.root}>
      <Grid container spacing={6}>
        <Grid container item xs={12} sm={6} alignItems="center">
          <Typography variant="h6" component={'span'}>
            {`لیست کاربران`}
          </Typography>
        </Grid>
        <Grid item sm={6} xs={12}>
          <RenderFilter
            filters={filters}
            onFilter={(filtervalues: any) => {
              setFiltersValues({
                ...removeEmptyValueObject(filtervalues),
                page: 0,
                size: 10,
              });
            }}
            mainFiltersCount={0}
            baseFilter={{
              type: 'input',
              id: 'name.contains',
              placeholder: 'نام کاربر',
            }}
            filterValues={filtersValues}
          />
        </Grid>
        <Grid xs={6} item container alignItems="center">
          {/* {props.loading ? (
            ''
          ) : (
            <>
              <div className={classes.subtitle}>{`تعداد کل کاربران:`}</div>
              <div>
                &nbsp;
                <b>{`${props.count}`}</b>
              </div>
            </>
          )} */}
        </Grid>
        <Grid container item xs={6} direction="row-reverse">

          <Can
            role={authContext.user.role}
            perform="user:createNewUser"
            yes={() => (
              <Button
                variant="contained"
                color="secondary"
                size="large"
                startIcon={<Icon path={mdiPlus} size={1} />}
                onClick={() => {
                  setOpenAdd(true);
                }}
              >{`ایجاد کاربر جدید`}</Button>
            )}
          />
        </Grid>
      </Grid>

      <Grid container spacing={3}>
        <Grid item xs={12}>
          {props.loading ? (
            <div className={classes.loading}>
              <CircularProgress />
            </div>
          ) : (
            <>
              <List
                data={props.customersList}
                handleOpenConfirmDisable={handleOpenConfirmDisable}
                handleOpenConfirmActive={handleOpenConfirmActive}
                handleOpen={handleOpen}
                changeStatus={handleOpenConfirmUpdateState}
                head={head}
                filterVal={filtersValues}
                onFilterValue={(filtervalues: any) => {
                  setFiltersValues({
                    ...removeEmptyValueObject(filtervalues),
                    ...filtersValues,
                    page: 0,
                    size: 10,
                  });
                }}
                removeFilterHandler={removeFilterHandler}
                filterLabelTranslator={filterTranslator}
              />
            </>
          )}
        </Grid>
        <Grid item xs={12} sm={6}>
          <FormControl
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
            }}
          >
            <div style={{ marginLeft: '10px', color: '#8a8a8a' }}>
              {' '}
              تعداد نمایش در هر صفحه:
            </div>
            <Select
              open={openSize}
              onClose={handleClose}
              onOpen={() => setOpenSize(true)}
              value={filtersValues.size}
              onChange={handleChangeSizePage}
            >
              <MenuItem value={10}>10</MenuItem>
              <MenuItem value={20}>20</MenuItem>
              <MenuItem value={50}>50</MenuItem>
              <MenuItem value={100}>100</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <Grid xs={12} sm={6} container item direction="row-reverse">
          <Pagination
            className={classes.pagination}
            count={Math.ceil(props.count / filtersValues.size)}
            color="secondary"
            page={filtersValues.page + 1}
            onChange={handleChangePage}
          />
        </Grid>
      </Grid>
      <Modal
        onClose={handleClose}
        maxWidth={'lg'}

        open={openDialog}
        title={
          <div >




          </div>
        }
        content={
          <>
            <div style={{ width: '500px' }} >

              <Typography>
                سازمان را انتخاب کنید:
              </Typography>
              <TextField
                name='organs'
                fullWidth
                variant='outlined'
                select >
                {
                  props.organsList?.map(item => {
                    return (

                      <MenuItem
                        value={item.id}
                        onClick={() => setOrgan(item.id)}
                      >
                        {item.name}
                      </MenuItem>
                    )
                  })
                }

              </TextField>
            </div>
          </>
        }
        actions={
          <>
            <Button variant='contained' onClick={() => (setOpenDialog(false))}>
              انصراف
            </Button>
            <Button color='primary' variant='contained' onClick={handleOrgans} >
              تایید و ادامه
            </Button>
          </>
        }
      />
    </div>
  );
};

const mapStateToProps = createStructuredSelector<Store, SelectorProps>({
  customersList: makeSelectCustomersList(),
  organsList: makeSelectOrgansList(),
  usersList: makeSelectUsersList(),
  partnersList: makeSelectPartnersList(),
  centersList: makeSelectCentersList(),
  count: makeSelectCountList(),
  loading: makeSelectLoading(),
  error: makeSelectError(),
});

function mapDispatchToProps(dispatch: Function) {
  return {
    costomersDispatch: (payload: Object) => dispatch(getCustomersAction(payload)),
    getOrganDispatch: (payload: Object) => dispatch(getOrgansAction(payload)),
    postOrganDispatch: (payload: Object) => dispatch(postOrgansAction(payload)),
    usersDispatch: (payload: Object) => dispatch(getUsersAction(payload)),
    updateUserDispatch: (payload: PayloadUpdate) =>
      dispatch(updateUserActions(payload)),
    createUserDispatch: (payload: PayloadCreate) =>
      dispatch(createUserActions(payload)),
    updateUserStatusDispatch: (payload: {
      id: number;
      body: string;
      pagination: object;
    }) => dispatch(updateUserStatusActions(payload)),
    centersDispatch: (payload: Object) => dispatch(getCentersAction(payload)),
    partnersDispatch: (payload: Object) => dispatch(getPartnersAction(payload)),
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withConnect)(UsersHelpical);
